import { cssVar } from './cssVar'

/**
 * Agent-response surface tokens (Stage 1).
 *
 * References only — every name here must also be *defined* in BOTH the `:root`
 * and `[data-theme='dark']` blocks of `src/scss/index.scss`. A token declared
 * here but missing there resolves to `var(--undefined)` and silently inherits
 * whatever the parent had, which looks like a styling bug with no error.
 * `scripts/check-contrast.mjs` fails the build if a referenced token is absent.
 */
export const statusTokens = {
  open: {
    fg: cssVar('--app-status-open-fg'),
    bg: cssVar('--app-status-open-bg'),
    border: cssVar('--app-status-open-border'),
  },
  blocked: {
    fg: cssVar('--app-status-blocked-fg'),
    bg: cssVar('--app-status-blocked-bg'),
    border: cssVar('--app-status-blocked-border'),
  },
  done: {
    fg: cssVar('--app-status-done-fg'),
    bg: cssVar('--app-status-done-bg'),
    border: cssVar('--app-status-done-border'),
  },
  unclear: {
    fg: cssVar('--app-status-unclear-fg'),
    bg: cssVar('--app-status-unclear-bg'),
    border: cssVar('--app-status-unclear-border'),
  },
}

export const responseTokens = {
  card: {
    bg: cssVar('--app-response-card-bg'),
    border: cssVar('--app-response-card-border'),
    title: cssVar('--app-response-card-title'),
    body: cssVar('--app-response-card-body'),
    shadow: cssVar('--app-response-card-shadow'),
  },
  rule: cssVar('--app-response-rule'),
  phase: {
    fg: cssVar('--app-phase-fg'),
    bg: cssVar('--app-phase-bg'),
    border: cssVar('--app-phase-border'),
  },
  status: statusTokens,
}
